/**
 * Version du cache de l'application
 * 
 * Incrémenter cette version force un rechargement complet du cache
 * pour tous les utilisateurs après un déploiement.
 * 
 * À incrémenter quand :
 * - La structure des données en base change (nouvelles colonnes, etc.)
 * - Le format des données transformées change
 * - Des bugs de cache nécessitent un reset
 * 
 * Historique :
 * - v1 : Version initiale
 * - v2 : Ajout de la colonne first_name dans la table contacts
 */
export const CACHE_VERSION = 'v1'
